<div class="bonus-order-widget">
  <span class="text-c1-m-500 text-md-b4-l-500">{{ providingBonusForOrder().message }}</span>
  <div class="bonus-order-widget-steps">
    @for (step of providingBonusForOrder().steps; track step) {
      <div class="bonus-order-widget-steps-item">
        <div class="bonus-order-widget-steps-item-line">
          <div class="progress-fill" [style.width.%]="step.percent"></div>
        </div>
        <div class="bonus-order-widget-steps-item-amount" [class.zero-percent]="!step.percent">
          <span class="text-b4-s-500 text-md-b4-m-500 color-black">
            {{ step.bonusAmount }}
          </span>
          <sd-icon class="icon-size-xxs" [type]="!step.percent ? iconTypes.BONUS_DISABLED : iconTypes.BONUS"></sd-icon>
        </div>
      </div>
    }
  </div>
</div>
